import { useContext, useEffect } from 'react';
import { CreateGroupChatContext } from '~/pages/CreateGroupChat';
import * as S from '~/pages/CreateGroupChat/index.styled';
import { FlexStack } from '~/components/atomic';
import { SetAICharacterCard } from '~/components/atomic/Skeleton';
import { useGetSearchCharacterListQuery } from '~/features/character';
import { useIntersectionObserver } from '~/hooks';
import { makeIndexArray } from '~/utils';
import SelectAiCard from '../SelectAiCard/SelectAiCard';
import { isMaxSelectedProps } from './MyFavoriteCharacters';

export default function ExploreCharacters({
  isMaxSelected,
}: isMaxSelectedProps) {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
  });
  const {
    data: allList,
    isFetchingNextPage,
    fetchNextPage,
  } = useGetSearchCharacterListQuery({});

  useEffect(() => {
    if (isIntersecting) {
      fetchNextPage();
    }
  }, [isIntersecting]);

  const {
    selectedAiCharacter,
    handleDeleteCharacterClick,
    handleAddCharacterClick,
  } = useContext(CreateGroupChatContext);

  return (
    <FlexStack>
      <S.SectionTitle>Explore</S.SectionTitle>

      {allList.pages.map((el) => {
        const isSelected = selectedAiCharacter.some(
          (s) => s.character_id === el.character_id,
        );

        return (
          <SelectAiCard
            key={el.character_id}
            name={el.character_name}
            description={el.character_desc}
            like={el.liked_count}
            isSelected={isSelected}
            imageUrl={el.character_image}
            createUsername={el.create_username}
            onClick={() =>
              isSelected
                ? handleDeleteCharacterClick(el)
                : handleAddCharacterClick(el)
            }
            isMaxSelected={isMaxSelected}
          />
        );
      })}

      {isFetchingNextPage ? (
        <FlexStack>
          {makeIndexArray(6).map((e) => (
            <SetAICharacterCard key={e} />
          ))}
        </FlexStack>
      ) : (
        <div ref={ref} />
      )}
    </FlexStack>
  );
}
